import { useRef } from 'react';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ScrollToTop } from '@/components/atoms';
import { LetsBuildStandaloneSection } from '@/components/sections/common';
import { SectionContentWrapper, SectionWrapper } from '@/components/wrappers';
import { Alphabet } from '@/utils/models/inventory-items';

import { InventoryAllHeading } from '../InventoryAllHeading';
import { LettersList } from '../LettersList';
import { LazyTitlesByLetter } from '../TitlesList/LazyTitlesByLetter';

interface InventoryAllProps {
  letters: Alphabet[];
}

export const InventoryAll = ({ letters }: InventoryAllProps) => {
  const containerRef = useRef(null);

  return (
    <SectionWrapper>
      <SectionContentWrapper ref={containerRef}>
        <InventoryAllHeading />
        <Flex
          flexDirection={{ base: 'column', md: 'row' }}
          alignItems={{ md: 'center' }}
          mt={{ md: '60px' }}
          gap={{ md: 6 }}
        >
          <LettersList letters={letters} />
        </Flex>

        <Flex
          flexDirection={{ base: 'column', sm: 'row' }}
          alignItems={{ lg: 'flex-start' }}
          gap={{ lg: 8 }}
          mt={{ sm: '200px' }}
        >
          <Box flex="1">
            {letters.map(({ letter }) => {
              return (
                <Flex
                  id={letter}
                  key={`letters-with-titles-list-letter-${letter}`}
                  flexDirection={{ base: 'column', sm: 'row' }}
                  alignItems={{ sm: 'flex-start' }}
                  justifyContent={{ sm: 'flex-start' }}
                  pb={{
                    base: '12',
                    sm: '24',
                    lg: '36',
                  }}
                  minH={{
                    base: '250px',
                    md: '300px',
                  }}
                >
                  <Heading
                    as="h2"
                    color="text-dark.500"
                    fontFamily="body"
                    fontSize="160px"
                    lineHeight="100%"
                    fontWeight="normal"
                    mt={{ base: 10, sm: 0 }}
                    w="110px"
                    textAlign="center"
                    flexShrink={0}
                  >
                    {letter}
                  </Heading>
                  <LazyTitlesByLetter letter={letter} />
                </Flex>
              );
            })}
          </Box>
        </Flex>
      </SectionContentWrapper>
      <Box w="100%" overflow="hidden">
        <LetsBuildStandaloneSection />
      </Box>
      <ScrollToTop />
    </SectionWrapper>
  );
};
